export type MonthlySummary = {
  employee_code: string;
  period_start: string;
  period_end: string;
  records_count: number;
  days_worked: number;
  attendance_count: number;
  total_work_minutes: number;
  total_work_hours: string | number;
  overtime_minutes: number;
  night_shift_count: number;
  unconfirmed_count: number;
};

export type DayRow = {
  work_date: string;
  duty_type: string | null;
  clock_in_at: string | null;
  clock_out_at: string | null;
  break_minutes: number;
  work_minutes: number;
  work_hours: string | number;
  status: string | null;
};

export const firstDayOfMonth = (date: Date): Date =>
  new Date(date.getFullYear(), date.getMonth(), 1);

export const toISODate = (date: Date): string => {
  // ISO 文字列に変換する際にタイムゾーンの影響で前日になるのを防ぐため、オフセットを補正してから処理する
  const offsetMinutes = date.getTimezoneOffset();
  const adjusted = new Date(date.getTime() - offsetMinutes * 60_000);
  return adjusted.toISOString().slice(0, 10);
};

export const minutesToJa = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours}時間${mins}分`;
};
